const initNavOverlay = () => {
  const overlay = document.getElementById("nav-overlay");
  const openBtn = document.getElementById("nav-toggle");
  const closeBtn = document.getElementById("nav-close-button");
  if (!overlay || !openBtn || !closeBtn) return;

  const open = () => {
    overlay.hidden = false;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    openBtn.setAttribute("aria-expanded", "true");
  };
  const close = () => {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    overlay.hidden = true;
    openBtn.setAttribute("aria-expanded", "false");
  };

  openBtn.addEventListener("click", (e) => {
    e.preventDefault();
    open();
  });
  closeBtn.addEventListener("click", (e) => {
    e.preventDefault();
    close();
  });
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay || e.target.closest("a")) close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !overlay.hidden) close();
  });
};
export default initNavOverlay;
